import React from 'react';
export function HeroSection() {
  return <section className="w-full" data-id="element-86">
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771284601/1_wlmyae.png" alt="ADN Campeón" className="w-full h-auto block" data-id="element-87" />
    </section>;
}